import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ServiceViewComponent } from './service-view/service-view.component';
import { ServiceFormComponent } from './service-form/service-form.component';

const routes: Routes = [
    {
        path: '',
        data: {
            title: 'Service',
          },
        component: ServiceViewComponent,
    }
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ServiceRoutingModule { }
